import Link from 'next/link'
import ShopifyImage from './shopifyImage'

export function ProductCardIndex({ name, imageData, href }) {
  return (
    <Link href={href}>
      <a>
        <div className="text-center">
          {/* <div className="relative w-full pb-[100%]"> */}
          {imageData !== null ? (
            <ShopifyImage
              imageData={imageData}
              className="h-auto w-full"
              // className="absolute h-full w-full object-cover"
            />
          ) : null}
          {/* </div> */}
          <h3 className="mt-4 font-medium uppercase text-gray-800">{name}</h3>
          <div className="mt-4">
            <span className="inline-block border-2 border-orange px-4 py-2 font-medium uppercase text-orange">
              Voir l'article
            </span>
          </div>
        </div>
      </a>
    </Link>
  )
}

export function ProductCardCategorie({ name, imageData, href, collectionName }) {
  return (
    <Link href={href}>
      <a>
        <div className="bg-yellow-50 p-8">
          <div className="text-center">
            {/* <div className="relative w-full pb-[100%]"> */}
            {imageData !== null ? (
              <ShopifyImage
                imageData={imageData}
                className="h-auto w-full"
                // className="absolute h-full w-full object-cover"
              />
            ) : null}
            {/* </div> */}
            <h3 className="mt-4 text-sm font-medium uppercase text-gray-700">{collectionName}</h3>
            <h2 className="mt-2 font-serif text-xl font-medium">{name}</h2>
            <div className="mt-4">
              <span className="inline-block border-2 border-orange px-4 py-2 font-medium uppercase text-orange">
                Voir l'article
              </span>
            </div>
          </div>
        </div>
      </a>
    </Link>
  )
}

export function ProductCardRecommendation({ name, imageData, href }) {
  // Manualu added to product page, strange bug
  return (
    <Link href={href}>
      <a>
        <div className="text-center">
          {imageData !== null ? (
            <ShopifyImage
              imageData={imageData}
              className="h-auto w-full"
              // className="absolute h-full w-full object-cover"
            />
          ) : null}
          <h3 className="mt-4 font-medium uppercase text-gray-800">{name}</h3>
          <div className="mt-4">
            <span className="inline-block border-2 border-orange px-4 py-2 text-sm font-medium uppercase text-orange">
              Voir l'article
            </span>
          </div>
        </div>
      </a>
    </Link>
  )
}
